/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index icon-primary to autogenerate all the components and extensions
 * Used by "prepareIconPrimarys"
 */

import IconPrimary from './icon-primary/IconPrimary'
export * from './icon-primary/IconPrimary'
export default IconPrimary
